import React from 'react';
import { Link } from 'react-router-dom';

// Shown on AI pages when the selected site is not verified yet.
const VerifyToUnlock: React.FC<{ feature: string }> = ({ feature }) => (
  <div className="card border-0 shadow-sm">
    <div className="card-body text-center py-5">
      <i className="bi bi-patch-check text-primary" style={{ fontSize: '3rem' }} />
      <h5 className="mt-3">Verify your site to unlock {feature}</h5>
      <p className="text-muted mx-auto" style={{ maxWidth: 520 }}>
        AI features are available for websites whose ownership is verified. Install the CloudAyn tracking
        script on your site — once we receive data from it, your site is verified automatically.
      </p>
      <Link to="/integration" className="btn btn-primary">
        <i className="bi bi-code-slash me-2" />Install tracking script
      </Link>
    </div>
  </div>
);

export default VerifyToUnlock;
